import { render } from "./ModalWithArrow.vue?vue&type=template&id=868e34ec&scoped=true"
import script from "./ModalWithArrow.vue?vue&type=script&lang=js"
export * from "./ModalWithArrow.vue?vue&type=script&lang=js"

import "./ModalWithArrow.vue?vue&type=style&index=0&id=868e34ec&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-868e34ec"]])

export default __exports__